import LocalizedStrings from 'react-localization';
import {languages} from './Languages';

export const strings = new LocalizedStrings(languages);